// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"285ab192","319":"c83aca98","410":"399f52e8","440":"f88c649c","455":"3f56b2a0","488":"07aeec02","593":"fbdcc109","612":"83e94637","883":"1c79da7c","977":"903cdee8"}[chunkId] + ".chunk.js";
};